type IconProps = React.ComponentProps<'svg'>

export function Contrast02Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(1.25, 1.25)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.75 3.5c4.00407 0 7.25 3.24594 7.25 7.25 0 4.00407-3.24593 7.25-7.25 7.25-0.41421 0-0.75-0.33579-0.75-0.75l0-13c0-0.41421 0.33579-0.75 0.75-0.75z m0.75 12.94922c2.82112-0.36764 5-2.77787 5-5.69922 0-2.92139-2.17882-5.33261-5-5.7002l0 11.39942z m-0.75-16.44922c5.93706 0 10.75 4.81294 10.75 10.75 0 5.93706-4.81294 10.75-10.75 10.75-5.93706 0-10.75-4.81294-10.75-10.75 0-5.93706 4.81294-10.75 10.75-10.75z m0 1.5c-5.10863 0-9.25 4.14137-9.25 9.25 0 5.10863 4.14137 9.25 9.25 9.25 5.10863 0 9.25-4.14137 9.25-9.25 0-5.10863-4.14137-9.25-9.25-9.25z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}
